import { Navigate, useLocation } from 'react-router-dom'
import { useUser } from '../../hooks/user/useUser'
import { ScreenPath } from '../../navigation'
import styles from '../../ui/onboarding/GuardView.module.css'
import LoadingIndicator from '../../ui/util/LoadingIndicator'

export interface AuthRequiredViewProps {
  children: JSX.Element
}

export default function AuthRequiredView({ children }: AuthRequiredViewProps) {
  const location = useLocation()
  const { data: user, isLoading, isFetching } = useUser()

  if (isLoading || (isFetching && !user)) {
    return (
      <div className={styles.loading}>
        <LoadingIndicator />
      </div>
    )
  }

  if (!user) {
    return (
      <Navigate
        to={ScreenPath.signup}
        state={{ from: location.pathname + location.search }}
        replace
      />
    )
  }

  return <>{children}</>
}
